import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SimulationTypeEnum } from "../../pages/AllSimulations/AllSimulations";
import { CanvasDraw } from "../../pages/DetailsPages/CanvasDraw";
import { Center, Modal, Text } from "@mantine/core";
import { Mixpanel } from "../../utilities/Mixpanel/MixpanelHelper";
import { WebAppEvents } from "../../utilities/Mixpanel/AnalyticeEventWebApp";
import { ContentSimulation } from "../../pages/SimulationPage/ContentSimulation";
import {
  getCondensedSimulationById,
  getSimulationById,
} from "../../features/Simulations/getSimulationSlice";
import {
  GetUser,
  GetValueFromLocalStorage,
  LocalStorageKey,
} from "../../utilities/LocalstorageUtility";
import { automaticLoginUser } from "../../features/auth/automaticLoginSlice";
import { AppDispatch } from "../../store/ReduxStore";
import { useDispatch } from "react-redux";
import { ContentSimulationNew } from "../../pages/SimulationPage/ContentSimulationNew";

export function SimulationsLoaderMiddleware(props: {
  simulationId?: string;
  onSimulationClosed?: () => void;
}) {
  const { simulationId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  const params = new URLSearchParams(location.search);
  const token = GetValueFromLocalStorage(LocalStorageKey.Token);
  const user = GetUser();

  const defaultLoginTokenForSimulations = params.get("def_token");
  const [instituteDetails, setInstituteDetails] = useState<{
    _id: string;
    name: string;
    icon: string;
  }>();

  const navigate = useNavigate();
  const [playSimulation, setPlaySimulation] = useState<{
    name: string;
    _id: string;
    url: string;
  } | null>(null);

  const [mySimulationId, setMysimualtionId] = useState<string | null>(null);

  useEffect(() => {
    if (token && user) {
      getCondensedSimulationById({
        id: simulationId ?? props.simulationId ?? "",
      })
        .then((x: any) => {
          simulationclickHandler({
            _id: x._id,
            name: x.name,
            simulationType: x.simulationType ?? 0,
            instituteId: user.instituteId,
            instituteName: user.instituteName,
          });
        })
        .catch((error) => {
          navigate("/");
        });
    } else if (defaultLoginTokenForSimulations) {
      dispatch(
        automaticLoginUser({ instituteId: defaultLoginTokenForSimulations })
      )
        .unwrap()
        .then((data) => {
          getCondensedSimulationById({ id: simulationId ?? "" })
            .then((x: any) => {
              simulationclickHandler({
                _id: x._id,
                name: x.name,
                simulationType: x.simulationType ?? 0,
                instituteId: data.user.instituteId._id,
                instituteName: data.user.instituteId.name,
              });
              setInstituteDetails({
                _id:data.user.instituteId._id,
                name:data.user.instituteId.name,
                icon:data.user.instituteId.schoolIcon
              })
            })
            .catch((error) => {
              navigate("/");
            });
        })
        .catch((error) => {
          Mixpanel.track(WebAppEvents.USER_SIGN_IN_FAILED, {
            error: error.message,
          });
        });
    } else {
      navigate("/");
    }
  }, []);

  function simulationclickHandler(data: {
    _id: string;
    name: string;
    simulationType: number;
    instituteId: string;
    instituteName: string;
  }) {
    Mixpanel.track(
      WebAppEvents.TEACHER_APP_SIMULATION_PAGE_SIMULATION_CLICKED,
      {
        simulationName: data.name,
        id: data._id,
      }
    );
    if (data.simulationType === SimulationTypeEnum.REACTIONJSON) {
      setPlaySimulation({
        ...data,
        url: `/${data.instituteName}/${data.instituteId}/teach1/all simulations/simulation/reactionmodelsimulation/${data._id}`,
      });
    } else if (data.simulationType === SimulationTypeEnum.MODELJSON) {
      setPlaySimulation({
        ...data,
        url: `/${data.instituteName}/${data.instituteId}/teach1/all simulations/simulation/anatomymodelsimulation/${data._id}`,
      });
    } else if (data.simulationType === SimulationTypeEnum.THREEJS) {
      setPlaySimulation({
        ...data,
        url: `/${data.instituteName}/${data.instituteId}/teach1/all simulations/simulation/${data._id}`,
      });
    } else {
      setPlaySimulation({ ...data, url: "" });
    }
  }
  return (
    <>
      <Modal
        opened={playSimulation !== null}
        onClose={() => {}}
        withCloseButton={false}
        closeOnClickOutside={false}
        styles={{
          inner: {
            padding: 0,
            margin: 0,
          },
          root: {
            padding: 0,
            margin: 0,
          },
          modal: {
            padding: 0,
            margin: 0,
          },
        }}
        style={{
          zIndex: 9999,
        }}
        size="auto"
        m={0}
        padding={0}
        lockScroll
        fullScreen
      >
        {playSimulation !== null && (
          <CanvasDraw
            onCloseClick={() => {
              Mixpanel.track(
                WebAppEvents.TEACHER_APP_LEARN_PAGE_CLOSE_SIMULATION_CLICKED
              );
              setPlaySimulation(null);
              if (props.simulationId) {
                props.onSimulationClosed?.();
              } else {
                navigate("/");
              }
            }}
            simulation={playSimulation}
            showCross={defaultLoginTokenForSimulations == null}
            instituteDetails={instituteDetails}
          >
            {!playSimulation.url || playSimulation.url.length == 0 ? (
              <Center
                style={{
                  height: "100%",
                  width: "100%",
                }}
              >
                <ContentSimulation
                  simulationId={playSimulation._id}
                  paramValue={"teacher"}
                  mySimulaitonId={mySimulationId}
                />
              </Center>
            ) : (
              <Center
                style={{
                  height: "100%",
                  width: "100%",
                }}
              >
                <ContentSimulationNew simulationUrl={playSimulation.url} />
              </Center>
            )}
          </CanvasDraw>
        )}
      </Modal>
    </>
  );
}
